<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1080 1920"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g class="swing">
      <g transform="matrix(0.5,0,0,0.5,896.739,152.632)">
        <path
          d="M0,612.701L-1388.53,612.701C-1435.7,612.701 -1478.27,570.14 -1478.27,522.967L-1478.27,89.734C-1478.27,42.561 -1435.7,0 -1388.53,0L0,0C47.173,0 89.734,42.561 89.734,89.734L89.734,522.967C89.734,570.14 47.173,612.701 0,612.701"
          style="fill: #fabb33; fill-rule: nonzero"
        />
      </g>
      <g transform="matrix(0.782135,0,0,0.782135,-1923.47,-3389.12)">
        <text
          x="3160px"
          y="4675px"
          style="
            font-family: 'Helvetica Neue', sans-serif;
            font-weight: 700;
            font-size: 100.072px;
            fill: #161743;
          "
          text-anchor="middle"
        >
          Jouw antwoord is
        </text>
        <text
          x="3160px"
          y="4850px"
          style="
            font-family: 'Helvetica Neue', sans-serif;
            font-weight: 500;
            font-size: 150px;
            fill: #161743;
          "
          text-anchor="middle"
        >
          {{ getScore }}
        </text>
      </g>
    </g>
    <g transform="matrix(1,0,0,1,0,0)">
      <text
        x="540px"
        y="600px"
        style="
          font-family: 'Helvetica Neue', sans-serif;
          font-weight: 500;
          font-size: 80px;
          fill: #fabb33;
        "
        text-anchor="middle"
      >
        Je hoort snel of je
      </text>
      <text
        x="540px"
        y="700px"
        style="
          font-family: 'Helvetica Neue', sans-serif;
          font-weight: 500;
          font-size: 80px;
          fill: #fabb33;
        "
        text-anchor="middle"
      >
        gewonnen hebt!
      </text>
    </g>
  </svg>
</template>

<script>
export default {
  name: "FinishScreen",
  created() {
    //this.$store.dispatch("getHiScore");
    this.timer = setInterval(this.gotoInactive, 15000);
  },
  computed: {
    getScore() {
      return this.$store.getters.getScore;
    },
  },
  methods: {
    gotoInactive() {
      this.$store.commit("setGameState", "inactive");
      this.$store.commit("setPlayerState", "ended");
    },
    getName(pos) {
      let hiScores = this.$store.getters.getHiScore;
      // Check if pos is within the bounds of the hiScores array
      if (pos < hiScores.length) {
        return hiScores[pos].name;
      } else {
        // Optional: return null or an empty string if pos is out of bounds
        return null;
      }
    },
    getScores(pos) {
      let hiScores = this.$store.getters.getHiScore;
      // Check if pos is within the bounds of the hiScores array
      if (pos < hiScores.length) {
        return hiScores[pos].score;
      } else {
        // Optional: return null or an empty string if pos is out of bounds
        return null;
      }
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>
